import React, { useState, useRef, Fragment, useEffect } from 'react';
import styled from '@emotion/styled';
import Lightbox from 'react-image-lightbox';
import { VIDEO_PREVIEW_DEFAULT } from '../../../../../constants/dashboardDiscoverMode';
import SliderPlayIcon from '../../../../../atoms/icons/SliderPlayIcon';
import SliderPauseIcon from '../../../../../atoms/icons/SliderPauseIcon';
import { useOffers } from '../../../../../contexts/OffersContext';
import breakpoints from 'theme/material/breakpoints';

const VideoContainer = styled('div')({
  background: 'rgba(0, 0, 0, 0.85)',
  position: 'fixed',
  zIndex: 1006,
  color: '#ffffff',
  textAlign: 'center',
  left: '50%',
  top: 60,
  transform: 'translate(-50%, 0)',
  maxWidth: 480,
  width: '100%',
  display: 'flex',
  alignContent: 'center',
  alignItems: 'center',
  [breakpoints.down(639.05)]: {
    maxWidth: 'none',
  },
});

const VideoAction = styled('div')({
  zIndex: 1001,
  height: '100%',
  width: '100%',
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const VideoPlayer = styled('video')({
  margin: '0 auto',
  width: 'calc(100% - 20px)',
  zIndex: 1000,
  backgroundColor: 'rgba(0, 0, 0, 0.85)',
  [breakpoints.down(834.05)]: {
    maxWidth: 'none',
    width: 'calc(100% - 20px)',
  },
});

const OneTapSwipeOfferVideoPreviewLightBox: React.FC = () => {
  const { videoPreview, setVideoPreview } = useOffers();
  const [showPlayButton, setShowPlayButton] = useState(false);
  const [showPauseButton, setShowPauseButton] = useState(true);

  const onCloseLightBox = () => {
    setVideoPreview(VIDEO_PREVIEW_DEFAULT);
    setShowPlayButton(false);
    setShowPauseButton(false);
  };

  const videoRef = useRef();

  const onVideoPlay = () => {
    if (videoPreview.media && videoRef && videoRef.current) {
      setTimeout(() => {
        // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
        videoRef.current
          .play()
          .then(() => {
            setShowPlayButton(false);
          })
          .catch(error => {
            console.error('The play() request was interrupted:', error);
          });
      }, 0);
    }
  };

  const handlePauseIconWhilePlaying = () => {
    setShowPlayButton(false);
    setShowPauseButton(true);
    setTimeout(() => {
      setShowPauseButton(false);
    }, 100);
  };

  const onVideoPause = () => {
    if (videoPreview.media && videoRef && videoRef.current) {
      // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
      videoRef.current.pause();
      setShowPlayButton(true);
      setShowPauseButton(false);
    }
  };

  useEffect(() => {
    if (videoRef && videoPreview.media && videoRef.current) {
      // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
      videoRef.current.addEventListener('play', handlePauseIconWhilePlaying);
      return () => {
        // @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
        videoRef && videoRef.current && videoRef.current.removeEventListener('play', handlePauseIconWhilePlaying);
        setShowPlayButton(false);
        setShowPauseButton(false);
      };
    }
  }, [videoPreview.media, videoRef]);

  return videoPreview.media ? (
    <Fragment>
      <Lightbox
        animationDisabled
        mainSrc=""
        onCloseRequest={onCloseLightBox}
        clickOutsideToClose={true}
        enableZoom={false}
        reactModalStyle={{
          overlay: {
            background: 'rgba(0, 0, 0, 0.85)',
          },
        }}
        wrapperClassName="discover-mode-video-lightbox"
      />
      <VideoContainer>
        <VideoPlayer
          autoPlay={true}
          controls={!showPlayButton}
          playsInline
          ref={videoRef}
          poster={videoPreview.thumbnail}
          onEnded={() => {
            setShowPlayButton(true);
            setShowPauseButton(false);
          }}
        >
          <source src={videoPreview.media} />
        </VideoPlayer>
        {showPlayButton && (
          <VideoAction onClick={onVideoPlay} style={{ cursor: 'pointer' }}>
            <SliderPlayIcon style={{ position: 'absolute', cursor: 'pointer', width: 'auto' }} onClick={onVideoPlay} />
          </VideoAction>
        )}
        {showPauseButton && (
          <VideoAction onClick={onVideoPause} style={{ cursor: 'pointer' }}>
            <SliderPauseIcon
              style={{ position: 'absolute', cursor: 'pointer', width: 'auto' }}
              onClick={onVideoPause}
            />
          </VideoAction>
        )}
      </VideoContainer>
    </Fragment>
  ) : (
    <Fragment />
  );
};

export default OneTapSwipeOfferVideoPreviewLightBox;
